import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpOneViewApproved, ProfessionalRfpOneViewUnapproved, } from '@/components/pages/rfp/professional/ProfessionalRfpOneView';
import Layout from '@/container/Layout';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
import { isClientProfile } from '@/utils/resources/profile/profileType';
import { myPagePath, professionalRfpListPath } from '@/utils/router/links';
/** 共通のパンくずリスト */
const baseBreadcrumbs = [
    {
        link: myPagePath(),
        text: 'マイページ',
    },
    {
        link: professionalRfpListPath(),
        text: '募集中のプロジェクト',
    },
];
/**
 * コンサルタント：案件詳細ページのコンテンツ部分を表示するコンポーネント
 * @constructor
 */
export const RfpProfessionalOnePage = (props) => {
    const { profile, rfp } = props;
    const { name } = rfp;
    /** パンくずリスト */
    const breadcrumbs = [...baseBreadcrumbs, { text: name }];
    /** 閲覧申請が未承認状態か */
    const isUnapproved = rfp.data_type === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value;
    const isAdminRoleUser = isClientProfile(profile) ? profile.isAdmin : false;
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container' }, { children: isUnapproved ? (_jsx(ProfessionalRfpOneViewUnapproved, { breadcrumbs: breadcrumbs, rfp: rfp })) : (_jsx(ProfessionalRfpOneViewApproved, { breadcrumbs: breadcrumbs, isAdminUser: isAdminRoleUser, professionalId: profile.id, rfp: rfp })) })));
};
